export default {
    errors: {},

    setErrors(value){
        if (_.isEmpty(value)) {
            this.forgetErrors();

            return;
        }

        if (typeof value === 'object') {
            this.errors = {...value, ...this.errors};
        } else {
            this.errors = {'form': ['Something went wrong. Please try again or contact customer support.']};
        }
    },

    forgetErrors(field){
        if (typeof field === 'undefined') {
            this.errors = {};

            return;
        }

        if(Array.isArray(field)) {
            field.forEach((field) => delete this.errors[field]);

            return;
        }

        delete this.errors[field];
    },

    hasError(field){
        if (typeof field === 'undefined') {
            return Object.keys(this.errors).length !== 0;
        }

        return Object.prototype.hasOwnProperty.call(this.errors, field);
    },

    hasAnyError(fields = []){
        if (Object.keys(this.errors).length === 0) {
            return false;
        }

        return fields.some((field ) => {
            return Object.prototype.hasOwnProperty.call(this.errors, field);
        });
    },

    getError(field){
        if (typeof field === 'undefined') {
            return this.errors;
        }

        if (! this.hasError(field)) {
            return null;
        }

        if (! Array.isArray(this.errors[field])) {
            return this.errors[field];
        }

        return this.errors[field][0];
    },

    hasCustomerInformationErrors() {
        return this.hasAnyError([
            'customer.email',
            'customer.first_name',
            'customer.last_name',
            'customer.phone',
        ])
    },

    hasAddressErrors() {
        return this.hasAnyError([
            'customer.address',
            'customer.city',
            'customer.state',
            'customer.zip'
        ])
    },
};
